/**
 * загрузка картинок по скроллу
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {ImgLazy} from "base/assets/js/widget/ImgLazy.js";
export class ImgScrollLoader extends Widget{

	bRow = false; // если true, то элементы могут быть расположены в строчку
	bSkip = false;
	_bTimeout = 0;
	_bExec = 0;
	_aImgs = [];
	_fnTimeoutHandler;

	run() {

		this._my( { skip: 'b:bSkip', row: 'b:bRow' } );

		this._aImgs = this._rel()
			.child()
			.typeOf( ImgLazy )
			.canEmpty()
			.onAdd( ( oImgLazy ) => {
				if( this.bSkip ) {
					oImgLazy.load();
				} else {
					this._aImgs.push( oImgLazy );
				}
			} )
			.onDrop( ( oImgLazy ) => {
				let iIndex = this._aImgs.indexOf( oImgLazy );
				if( iIndex !== -1 ) {
					this._aImgs.splice( iIndex, 1 );
				}
			} )
			.find( true );

		if( this.bSkip ) {
			this._aImgs.forEach( ( oImgLazy ) => {
				oImgLazy.load();
			} )
			return;
		}

		this._fnTimeoutHandler = ::this.timeoutHandler;
		this.attach();
		this._fnTimeoutHandler();
	}

	attach() {
		this._on( window, 'scroll', this._fnTimeoutHandler );
	}

	detach() {
		this._offScroll();
	}

	destructor() {
		this.detach();
		super.destructor();
	}

	_offScroll() {
		if( this._fnTimeoutHandler ) {
			this._off( window, 'scroll', this._fnTimeoutHandler );
		}
	}

	fnHandler() {
		if( !this._aImgs.length ) {
			return true;
		}
		const iFrom = -window.innerHeight;
		const iTo = window.innerHeight * 2;
		this._bExec = 0;
		let i, oImg, oOffset, aDeleteIndexes = [];
		for( i = 0; i < this._aImgs.length; i++ ) {

			oImg = this._aImgs[ i ];

			try {
				oOffset = oImg.bl().getBoundingClientRect();
			} catch( e ) {
				return;
			}
			if ( oOffset.top > iFrom && oOffset.top < iTo ) {

				oImg.load();

				this._bExec = 1;
				aDeleteIndexes.push( i );
			}
			if( oOffset.top > iTo && !this.bRow ) {
				// нет смысла дальше общитывать, и так за пределами будет
				break;
			}
		}
		// обновляем список картинок, ведь какие то уже не надо обрабатывать
		if( this._bExec ) {
			let iDeleteIndex;
			// перевернем массив индексов для удаления, чтобы спокойно их выкидывать
			aDeleteIndexes = aDeleteIndexes.reverse();
			for( i = 0; i < aDeleteIndexes.length; i++ ) {
				iDeleteIndex = aDeleteIndexes[ i ];
				this._aImgs.splice( iDeleteIndex, 1 );
			}
		}
	}
	
	timeoutHandler() {
		if( this._bTimeout ) {
			return true;
		}

		// дополнительный таймаут, чтобы бесконечно не выполнять функцию hToggleBlock
		window.setTimeout(
			() => {
				this.fnHandler();
				this._bTimeout = 0;
			},
			300
		);
		this._bTimeout = 1;
	}
}